import { useState } from "react";
import { useTheme } from "../../../context/useThemeContext";
import { LoginField } from "../components/LoginField";
import { GoogleLogin, LoginButton } from "../components/LoginButton";
import RedirectBTN from "../components/RedirectBTN";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { TextDivider } from "../components/TextDivider";
import { useAccountManagementFunctions } from "../hooks/useAccountManagementFunctions";
import { useFormCooldown } from "../hooks/useFormCooldown";

export default function SignInView() {
    const { setLoginState } = useAccountManagementStore((state) => state);
    const { signInWithGoogle } = useAccountManagementFunctions();

    function logIn_Google() {
        signInWithGoogle();
    }

    return (
        <div className="flex flex-col p-9 pb-7 text-white">
            <TopLoginForm />
            <div className="flex w-full space-x-2 self-center text-sm">
                <RedirectBTN
                    name="Create account"
                    onClick={() => {
                        setLoginState("register");
                    }}
                />
                <div className="separator flex-grow-1 flex-1" />
                <RedirectBTN
                    name="Forgot password?"
                    onClick={() => {
                        setLoginState("forgotPassword");
                    }}
                />
            </div>
            <TextDivider middleText="or" />
            <GoogleLogin
                buttonText="Sign in with Google"
                callbackFunction={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    logIn_Google();
                }}
            />
        </div>
    );
}

function TopLoginForm() {
    const { theme } = useTheme();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [validLogin, setValidLogin] = useState(true);

    const { setUserData } = useAccountManagementStore((state) => state);
    const { signIn } = useAccountManagementFunctions();
    const { canSubmit, startCooldown } = useFormCooldown(1);

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (!canSubmit) return;

        const userData = await signIn(email, password);

        if (!userData) {
            setValidLogin(false);
            startCooldown();
        } else {
            setValidLogin(true);
            setUserData(userData);
        }
    }

    return (
        <form
            id="signInForm"
            className="flex flex-col text-center"
            onSubmit={onSubmit}
        >
            <b className="mb-4 text-2xl">Sign In</b>
            <LoginField
                fieldID="email"
                fieldTitle="Email"
                fieldType="email"
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                }}
                disableSpaces
            />
            <LoginField
                fieldID="password"
                fieldTitle="Password"
                fieldType="password"
                value={password}
                onChange={(e) => {
                    setPassword(e.target.value);
                }}
                invalidInput={!validLogin}
                errorMessage={validLogin ? "" : "Invalid login"}
            />
            <LoginButton
                type="submit"
                className="my-4 h-[36px] rounded text-sm"
                disabled={!canSubmit}
                style={{
                    backgroundColor: theme.accentColor,
                    opacity: canSubmit ? 1 : 0.5,
                    cursor: canSubmit ? "pointer" : "not-allowed",
                }}
            >
                Sign In
            </LoginButton>
        </form>
    );
}
